import React from 'react';
import { InjectedRouter } from 'react-router';

import CoachingConstants from 'coaching/CoachingConstants';
import CoachingSelfServeIntroView from 'coaching/components/CoachingSelfServeView/CoachingSelfServeIntroView';
import CoachingIsolatedViewHeader from 'coaching/components/CoachingIsolatedViewHeader';

type Props = {
  router: InjectedRouter;
};

export default function CoachingIntroContainer(props: Props) {
  return (
    <div className="CoachingIsolatedView">
      <CoachingIsolatedViewHeader />
      <CoachingSelfServeIntroView
        onContinue={() => props.router.push(CoachingConstants.COACHING_PURCHASE_REVIEW_ROUTE)}
      />
    </div>
  );
}
